import { ExperiencePerformanceTypes, ExperienceTypes, UFOExperience } from '@atlassian/ufo';
var keyToTiming = function keyToTiming(key) {
  return {
    key: key,
    startMark: "".concat(key, "_start"),
    endMark: "".concat(key, "_end")
  };
};
var timings = ['FetchedActivities', 'TransformedActivityItems', 'GeneratedQueryWithFilters'].map(keyToTiming);
export var recentWorkClientExperienceV2 = function recentWorkClientExperienceV2() {
  return new UFOExperience('client', {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.Custom,
    platform: {
      component: 'recent-work'
    },
    timings: timings
  });
};
export var recentWorkClientExperienceV3 = function recentWorkClientExperienceV3() {
  return new UFOExperience('client-v3', {
    type: ExperienceTypes.Load,
    performanceType: ExperiencePerformanceTypes.Custom,
    platform: {
      component: 'recent-work'
    },
    timings: timings
  });
};